module.exports = __webpack_public_path__ + "static/media/charity.3fdac35f.jpeg";